module.exports = __webpack_public_path__ + "img/in progress.a245b69f.svg";